import { I18n } from "@assets/strings";
import React from "react";
import styled from "styled-components";
import { CourseStatus } from "@domain/lms/course/courseDraft";
import { FilterIcon } from "@ui/components/icons";
import { row } from "@ui/components/layout";
import { Menu } from "@ui/components/menus/menu";
import { courseStatusColor } from "@ui/styles/colors";
import { gap } from "@ui/styles/utils";

interface CourseStatusFilterProps extends React.HTMLAttributes<HTMLDivElement> {
	status: CourseStatus | "ALL";
	onStatusChange: (newStatus: CourseStatus | "ALL") => void;
}
export const CourseStatusFilter: React.FC<CourseStatusFilterProps> = ({ status, onStatusChange, ...htmlProps }) => {
	return (
		<Menu
			bottomSheetMode
			closeOnSelect
			align="left"
			{...htmlProps}
			renderMenuContent={() => (
				<Content>
					{(["PUBLISHED", "ARCHIVED", "DRAFT", "ALL"] as const).map((status) => (
						<Row key={status} status={status} onClick={() => onStatusChange(status)}>
							• {I18n.t(`course.status.${status}`)}
						</Row>
					))}
				</Content>
			)}
		>
			<MenuLayout>
				<FilterIcon />
				<div>{I18n.t(`course.status.${status}`)}</div>
			</MenuLayout>
		</Menu>
	);
};

const MenuLayout = styled.div`
	${({ theme }) => theme.textStyles.primary};
	${row(8, "center")}
`;
const Content = styled.div`
	display: flex;
	flex-direction: column;
	${gap(20)}
	white-space: nowrap;
`;

const Row = styled.div.withConfig({
	shouldForwardProp: (prop) => prop !== "status",
})<{ status: CourseStatus | "ALL" }>`
	cursor: pointer;
	color: ${({ status }) => courseStatusColor[status]};
`;
